(() => {
  glowCookies.start("en", {
    style: 1,
    analytics: "UA-25570812-5",
    bannerHeading: "Can we use cookies?",
    bannerDescription:
      "We use cookies to gather statistics and improve your experience on our on-line user guides.",
    bannerLinkText: "Read our privacy policy.",
    policyLink: "https://www.genymotion.com/privacy-statement/",
    acceptBtnBackground: "white",
    acceptBtnColor: "#1d2e38",
    acceptBtnText: "Accept",
    rejectBtnBackground: "white",
    rejectBtnColor: "#1d2e38",
    rejectBtnText: "Decline",
  });
})();
